/* eslint-disable */
import axios from "axios"
import Promise from 'es6-promise'
const NODE_URI = process.env.API_NODE
const BASE_URI = process.env.HUB_URL
const IPIFY_URL = 'https://api.ipify.org'
import SessionManager from "@/utils/session-manager"


export default class HubConsultaClient {
  static getIP() {
    return new Promise((resolve, reject) => {
      this._requisitar({url: `${IPIFY_URL}?format=json`, method: 'GET'})
        .then(response => {
          resolve(response.data.ip)
        })
        .catch(error => reject(error))
    })
  }

  static pegarCeps(cep) {
    return new Promise((resolve, reject) => {
      this._requisitar({url: `${BASE_URI}/cep/${cep}`, method: 'GET'})
        .then(response => {
          resolve(response.data)
        })
        .catch(error => reject(error))
    })
  }

  static pegarEstados() {
    return new Promise((resolve, reject) => {
      // this._requisitar({url: `${BASE_URI}/iouu/estados`, method: 'GET'})
      //   .then(response => {
      //     const estados = response.data.map(estado => {
      //       return {uf: estado.dados.uf, nome: estado.dados.estado}
      //     })
      //     resolve(estados)
      //   })
      //   .catch(error => reject(error))

      this._requisitar({url: `${NODE_URI}/estados`, method: 'GET'})
        .then(response => {
          const estados = response.data.map(estado => {
            return {uf: estado.sigla, nome: estado.nome}
          })
          resolve(estados)
        })
        .catch(error => reject(error))
    })
  }

  static pegarCidades(uf) {
    return new Promise((resolve, reject) => {
      // this._requisitar({url: `${BASE_URI}/iouu/estados/${uf}/cidades`, method: 'GET'})
      //   .then(response => {
      //     const cidades = response.data.map(cidade => {
      //       return {uf: cidade.dados.uf, nome: cidade.dados.cidade}
      //     })
      //     resolve(cidades)
      //   })
      //   .catch(error => reject(error))
      this._requisitar({url: `${NODE_URI}/estados/${uf}/cidades`, method: 'GET'})
        .then(response => {
          const cidades = response.data.map(cidade => {
            return {uf: cidade.estado, nome: cidade.nome}
          })

          cidades.sort(function(a,b) {
            if(a.nome.toLowerCase() < b.nome.toLowerCase()) return -1;
            if(a.nome.toLowerCase() > b.nome.toLowerCase()) return 1;
            return 0;
          });

          resolve(cidades)
        })
        .catch(error => reject(error))
    })
  }

  static pegarBancos() {
    return new Promise((resolve, reject) => {
      this._requisitar({url: `${BASE_URI}/iouu/bancos`, method: 'GET'})
        .then(response => {
          resolve(response.data)
        })
        .catch(error => reject(error))
    })
  }

  static pegarPerguntas(cpf, attemptNumber=1) {
    return new Promise((resolve, reject) => {
      // THIS IS A WORKAROUND TO GIVE IT A FAST FIX
      // Actually what is needed to do here is to replicate what is done in the server,
      // with the function _getAsyncProcessResult in server/lib/utils/hub-consulta-client.js.
      // But before doing it, the HubConsulta endpoint should start to respond in the same way
      // as Ph3a endpoint and others that return a Status of async processing stuff.
      if(attemptNumber >= 5) {
        reject(new Error("Exceeded maximum attempts to get the questions"))
      }
      this._requisitar({url: `${BASE_URI}/bigID/pergunta/cpf/${cpf}`, method: 'GET'})
        .then(response => {
          const data = response.data
          if(data.DadosConsulta) {
						if(data.DadosConsulta.ResultCode == 0) {
							resolve(response.data)
						} else {
							throw new Error(data.DadosConsulta.ResultMessage)
						}
					} else {
						setTimeout(() => {
							this.pegarPerguntas(cpf, attemptNumber + 1)
								.then(result => resolve(result))
								.catch(error => reject(error))
						}, 1000)
					}
        })
        .catch(error => reject(error))
    })
  }

  /* Suitability*/
  static obterPerfilInvestidor(idSuitability) {
    return new Promise((resolve, reject) => {
      this._requisitar({url: `${BASE_URI}/iouu/suitability/${idSuitability}`, method: 'GET'})
        .then(response => {
            resolve(response)
        })
        .catch(error => reject(error))
    })
  }

  static _requisitar(options={}) {
    return axios(options)
  }

  static request(options={}) {
    return axios(this._prepareOptions(options))
  }

  static _prepareOptions(givenOptions) {
    if(!givenOptions.headers) { givenOptions.headers = {} }
    if(!givenOptions.headers["Accept"]) {
      givenOptions.headers["Accept"] = 'application/json'
    }
    if(!givenOptions.headers["Content-Type"]) {
      givenOptions.headers["Content-Type"] = 'application/json'
    }


    // const accessToken = SessionManager.getAuthToken()

    // if(accessToken) {
    //   givenOptions.headers = Object.assign(givenOptions.headers, {
    //     Authorization: `${accessToken}`
    //   })
    // }


    givenOptions.data = JSON.stringify(givenOptions.data)
    givenOptions.url = `${BASE_URI}/${givenOptions.url}`
    return givenOptions
  }

  static simulator(vr, n, fat, tipo) {
    return this.request({
      url: `iouu/calc`,
      method: 'POST',
      data: {
        vr: vr,
        n: n,
        fat: fat,
        tipo: tipo
      }
    })
    .then(response => {
      return response;
    })
  }

  static createLoans(data) {
    return this.request({
      url: 'iouu/solicitacao',
      method: 'POST',
      data: data
    })
    .then(response => {
      return response;
    })
    .catch((error) => {
      return error;
    })
  }

  static getPdf(cpf) {
    return new Promise((resolve, reject) => {
      this._requisitar({url: `${BASE_URI}/informe?cpf=${cpf}`, method: 'GET'})
        .then(response => {
            resolve(response)
        })
        .catch(error => reject(error))
    })
  }

  static downloadPdf(data) {
    return this.request({
      url: 'informe',
      method: 'POST',
      data: data
    })
    .then(response => {
      return response;
    })
    .catch((error) => {
      return error;
    })
  }
  
  static theCheckerPost(email) {
    return this.request({
        url: `theChecker/`+ email,
        method: 'GET',
      })
      .then(response => {
        return response.data;
      }).catch(error => {
        return reject(error);
      });
  }

  static PreValidacaoEmail(email) {
    return this.request({
        url: `verifyEmail/`+ email,
        method: 'GET',
      })
      .then(response => {
        return response.data;
      }).catch(error => {
        return reject(error);
      });
  }

  static ExisteUsuario(email) {
    return this.request({
      url: `existeUsuario/`+ email,
      method: 'GET',
    })
    .then(response => {
      return response.data;
    }).catch(error => {
      console.log(error)
      return error
    });
  }

  static GerarEstatistica() {
    return this.request({
      url: `GerarEstatisticas`,
      method: 'GET',
    })
    .then(response => {
      return response
    }).catch(error => {
      console.log(error)
      return error
    })
  }

  static GerarEstatisticaEmprestimo() {
    return this.request({
      url: `GerarEstatisticasEmprestimos`,
      method: 'GET',
    })
    .then(response => {
      return response
    }).catch(error => {
      console.log(error)
      return error
    })
  }

  static CadastrarActive(email) {
    return this.request({
      url: `active/cadastrar/${email}`,
      method: "GET"
    })
  }

  static AtualizarActive(email, tag) {
    return this.request({
      url: `active/atualizar/${email}/${tag}`,
      method: "GET"
    })
  }

  static CadastrarTomadorActive(email) {
    return this.request({
      url: `active/tomadores/${email}`,
      method: "GET"
    })
  }

  static ConsultaInvestidor(email) {
    return this.request({
        url: `iouu/consultaInvestidor/` + email,
        method: 'GET'
      })
      .then(response => {
        return response;
      }).catch((resp) => {
        console.log(resp)
      });
  }

  static ConsultaTerceiroDiaUtil(dia,mes, ano) {
    return this.request({
      url: `calendario/terceiroDiaUtil/${dia}/${mes}/${ano}`,
      method: 'GET'
    })
    .then((response) => {
      return response
    })
    .catch((error) => {
      console.log(error)
    })
  }

  static LeadSerasa(authCode) {
    return this.request({
      url: `call/serasa/${authCode}`, 
      method: 'GET'
    })
    .then((response) => {
      return response
    })
    .catch((resp) => {
      console.log(resp)
    })
  }

  static LeadTest() {
    return this.request({
      url: `teste/call/serasa`,
      method: 'GET'
    })
	.then((response) => {
		return response
	})
	.catch((error) => {
		console.log(error)
	})
  }

}



// WEBPACK FOOTER //
// ./src/utils/hub-consulta-client.js